import React from 'react'
import { Route, Switch } from 'react-router-dom'

import Login from 'areas/public/login/Login'
import CompleteLogin from 'areas/public/login/CompleteLogin'
import ResetPassword from 'areas/public/resetPassword/ResetPassword'
import RestorePassword from 'areas/public/restorePassword/RestorePassword'
import UserRegistration from 'areas/public/userRegistration/UserRegistration'
import Registration from 'areas/public/registration/Registration'
import ExpiredPassword from 'areas/public/expiredPassword/ExpiredPassword'
import NotFoundError from 'areas/shared/errors/notFound/NotFound'
import UserUnsubscribe from 'areas/public/userUnsubscribe/UserUnsubscribe'

class Routes extends React.Component {
  render() {
    return (
      <Switch>
        <Route path='/public/login' component={Login} />
        <Route path='/public/completeLogin' component={CompleteLogin} />
        <Route path='/public/resetPassword' component={ResetPassword} />
        <Route path='/public/restorePassword' component={RestorePassword} />
        <Route path='/public/userRegistration' component={UserRegistration} />
        <Route path='/public/expiredPassword' component={ExpiredPassword} />
        <Route path='/public/registration' component={Registration} />
        <Route path='/public/userUnsubscribe' component={UserUnsubscribe} />
        <Route path='*' component={NotFoundError} />
      </Switch>
    );
  }
}

export default Routes;



// WEBPACK FOOTER //
// ./src/layouts/public/routes/Routes.js